import { render, staticRenderFns } from "./CompanyDetails.vue?vue&type=template&id=6384d964&scoped=true"
import script from "./CompanyDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyDetails.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompanyDetails.vue?vue&type=style&index=0&id=6384d964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6384d964",
  null
  
)

export default component.exports